import React from "react";
import { ReleaseCardModel } from "./HomeLandingModel";
import ReleaseCard from "./ReleaseCard";
import ValuePicksRow from "./ValuePicksRow";

export default function NewestReleasesSection({
  title,
  newestReleases,
}: {
  title: string;
  newestReleases: readonly ReleaseCardModel[];
}) {
  const featured = newestReleases[0];
  const valuePicks = newestReleases.slice(1);

  return (
    <section className="homeLandingNewestReleasesSection">
      <div className="homeLandingSectionTitle">{title}</div>
      {featured ? <ReleaseCard item={featured} /> : (
        <div style={{ color: "#a3a3a3", paddingTop: "16px" }}>
          No real titles available yet.
        </div>
      )}
      {valuePicks.length > 0 && (
        <div className="homeLandingVFMSection">
          <div className="homeLandingVFMTitle">Value-for-money picks</div>
          <ValuePicksRow items={valuePicks} />
        </div>
      )}
    </section>
  );
}
